import { createAction } from "@coverme/redux";
import Axios from "axios";

export const addNote = (customerCode, personId, text) =>
    createAction("ADD_NOTE", () => {
        const body = {
            body: text,
        };
        return Axios.post(`/api/customer/${customerCode}/person/${personId}/notes`, body).then(data => data.data);
    });

export const getNotes = (customerCode, personId) =>
    createAction("GET_NOTES", () =>
        Axios.get(`/api/customer/${customerCode}/person/${personId}/notes`).then(data => ({
            personId: personId,
            notes: data.data,
        }))
    );
